import {lazy} from '@aboutyou/lazy-imports';

export const DatadogLogsRouteTracker = lazy(() =>
  import('./DatadogLogsRouteTracker.eager').then(mod => ({
    default: mod.DatadogLogsRouteTracker,
  })),
);
